import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setGetCashback} from '../../store/thunk/setGetCashback';
import TableCasino from '../../components/table';
import Title from '../../../../../@casino/ui/title';
import {columns, getRows} from './helpers';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { setPostCashback } from '../../store/thunk/setPostCashback';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        paddingTop: 0,
        color: '#fff'
    },
    wrap: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
        display: 'flex',
    },
    create: {
        padding: 10, 
        background: '#ffc324', 
        borderRadius: 4, 
        cursor: 'pointer', 
        color: '#141b33'
    },
    change: {
        padding: 10, 
        background: '#ffc324', 
        borderRadius: 4, 
        cursor: 'pointer', 
        color: '#141b33'
    },
    mt10: {
        marginTop: 10
    },
    mr12: {
        marginRight: 12
    },
    wrapBlock: {
        display: 'flex',
        flexDirection: 'column'
    },
    wrapLabel: {
        display: 'flex', 
        justifyContent: 'space-between', 
        width: '100%', 
        alignItems: 'center'
    },
    wrapTable: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    },
    wrapDialog: {
        width: 250, 
        height: 250, 
        padding: 20, 
        display: 'flex', 
        flexDirection: 'column'
    },
    titleDialog: {
        fontSize: 16, 
        textAlign: 'center'
    },
    labelTitle: {
        fontFamily: 'Calibri, sans-serif', 
        color: '#2f2f2f'
    },
    inputStyle: {
        fontFamily: 'Calibri, sans-serif',
        width: 215,
        overflow: 'hidden',
        border: '1px solid rgb(229, 229, 229)',
        borderRadius: 4,
        padding: '14px 20px 13px 10px',
        fontSize: '16px',
        lineHeight: '16px',
        height: 16,
        outline: 'none',
    },
    createBtn: {
        border: 'none',
        background: 'rgb(255, 206, 1)',
        borderRadius: 4,
        marginTop: 12,
        padding: 10
    },
    rootFilter: {
        padding: 20, 
        paddingTop: 0
    },
    wrapBlockFilter: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    },
    searchGamerFilter: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: '97.3%'
    },
}))

const CashbackList = () => {
    const dispatch = useDispatch();
    const classes = useStyles();

    React.useEffect(() => {
        dispatch(setGetCashback({
            page: 1,
            rowsPerPage: 10
        }))
    }, []);

    const list = useSelector(state => state.cashback.list);

    const rows = React.useMemo(() => getRows(list.data), [list]);
 
    return (
        <div className={classes.root}>
            <Title
                label="Cashback"
                labelBtn="Выдать всем"
                button={() => dispatch(setPostCashback())}
            />
            <div className={classes.wrapTable}>
                <TableCasino 
                    pagination
                    allPage={list.countPage}
                    width={1300}
                    perPage={10}
                    columns={columns}
                    rows={rows}
                    changePage={(v) => dispatch(setGetCashback({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetCashback({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                    }))}
                />
            </div>
        </div>
    )
}

export default CashbackList;